import { CardTraderLanguageValueType } from "magic-shared-types";
import { StyledSelect } from "../common.style";
import { Option } from "../../primitives";

interface LanguageDropdownProps {
  language: CardTraderLanguageValueType;
  setLanguageValue: (arg1: CardTraderLanguageValueType) => void;
}

export const LanguageDropdown = ({
  setLanguageValue,
  language,
}: LanguageDropdownProps) => {
  return (
    <StyledSelect
      value={language}
      onChange={(e) =>
        setLanguageValue(e.target.value as CardTraderLanguageValueType)
      }
    >
      <Option value="">All Languages</Option>
      <Option value="en">🇬🇧 English</Option>
      <Option value="fr">🇫🇷 French</Option>
      <Option value="de">🇩🇪 German</Option>
      <Option value="es">🇪🇸 Spanish</Option>
      <Option value="it">🇮🇹 Italian</Option>
      <Option value="zn-ch">🇨🇳 Simplified Chinese</Option>
      <Option value="jp">🇯🇵 Japanese</Option>
      <Option value="pt">🇵🇹 Portuguese</Option>
      <Option value="ru">🇷🇺 Russian</Option>
      <Option value="kr">🇰🇷 Korean</Option>
      <Option value="zh-tw">🇹🇼 Traditional Chinese</Option>
    </StyledSelect>
  );
};
